export default {
    timeout: 5000,
    position: 'top right'
}